import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

export const isProduction = true;

const firebaseConfig = {
    apiKey: "AIzaSyCbzXD-EDyLAZ5S4E2jbiM6po5OMtwPXyg",
    authDomain: "hitmovie-production.firebaseapp.com",
    databaseURL: "https://hitmovie-production-default-rtdb.firebaseio.com",
    projectId: "hitmovie-production",
    storageBucket: "hitmovie-production.appspot.com",
    messagingSenderId: "251780212145",
    appId: "1:251780212145:web:0e407164f3d5b5e920c990",
    measurementId: "G-T0KCZX313S"
};
const firebaseConfigStage = {
    apiKey: "AIzaSyDhxKiZrbVbtw-NQHT9ZSn2Djh4f8PWTOg",
    authDomain: "hitmovie-be876.firebaseapp.com",
    databaseURL: "https://hitmovie-be876.firebaseio.com",
    projectId: "hitmovie-be876",
    storageBucket: "hitmovie-be876.appspot.com",
    messagingSenderId: "16400676290",
    appId: "1:16400676290:web:cb8fdd5d77426d09b3525b",
    measurementId: "G-BFRC8LWE77"
};

firebase.initializeApp(isProduction ? firebaseConfig : firebaseConfigStage);
// firebase.analytics();
export default firebase;